import { AxiosInstance } from "axios"
import { BillReceiversItem } from "../../../modules/company/admin/accounting/bill-receivers/billReceiversTypes"
import { BillReceiver } from "./billReceiverTypes"

export type CreateBillReceiversParams = Readonly<{
    billReceiver?: BillReceiver
}>

type CreateBillReceiversResponse = Readonly<{
    billReceiver: BillReceiversItem
}>

export async function createBillReceivers(
    { billReceiver }: CreateBillReceiversParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CreateBillReceiversResponse> {
    const url = "/billReceivers"
    const { data } = await axios.post(
        url,
        {
            billReceiver,
        },
        {
            signal,
        },
    )

    return data
}
